import api from './axios';
import axios from 'axios';

export const getDossiers   = ()         => api.get('/dossiers/');
export const getDossier    = (id)       => api.get(`/dossiers/${id}/`);
export const createDossier = (data)     => api.post('/dossiers/', data);
export const updateDossier = (id, data) => api.patch(`/dossiers/${id}/`, data);
export const deleteDossier = (id)       => api.delete(`/dossiers/${id}/`);
export const getStats      = ()         => api.get('/dossiers/stats/');
export const avancerStatut = (id, data) => api.post(`/dossiers/${id}/avancer_statut/`, data);
export const assignerAgent = (id, data) => api.post(`/dossiers/${id}/assigner_agent/`, data);
export const commenter     = (id, data) => api.post(`/dossiers/${id}/commenter/`, data);
export const terminerEtape = (id, data) => api.post(`/dossiers/${id}/terminer_etape/`, data);
export const validerEtape  = (id, data) => api.post(`/dossiers/${id}/valider_etape/`, data);
export const getAgents     = ()         => api.get('/users/agents/');


export const getRapport       = (dossierId) => api.get(`/rapports/?dossier=${dossierId}`);
export const createRapport    = (data)       => api.post('/rapports/', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
});

export const telechargerPdfRapport = (rapportId) =>
    api.get(`/rapports/${rapportId}/telecharger_pdf/`, {
        responseType: 'blob'    // ← important pour les fichiers binaires
    });

export const updateRapport    = (id, data)   => api.patch(`/rapports/${id}/`, data);
export const soumettreRapport = (id)         => api.post(`/rapports/${id}/soumettre/`);
export const corrigerRapport  = (id, data)   => api.post(`/rapports/${id}/corriger/`, data);
export const envoyerRapport   = (id)         => api.post(`/rapports/${id}/envoyer/`);
export const cloturerDossier  = (id, data)   => api.post(`/dossiers/${id}/cloturer/`, data);
export const repondreDossier  = (id, data)   => api.post(`/dossiers/${id}/repondre/`, data);


const publicApi = axios.create({ baseURL: '/api' });

export const demandeDemo = (data) => publicApi.post('/dossiers/demo/', data);
